<template>
	<div style="text-align: center;padding-top:20%;">
        <span class="desText">404</span>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
			};
		},
		methods: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="scoped">
	// *{outline: 1px solid blue}
    .desText{font-size: 100px;color:#aaa;}
</style>



// WEBPACK FOOTER //
// src/pages/error.vue